const ClientGroupList_query = `
    query(
      $clientId: Int!      
    ) {
      getAllClientGroups(
        clientId: $clientId        
      ) {
          groupId
          groupUuid
          name
          desc
          deletable
          clientId
          {
            clientId
            clientUuid
            tenantId
            {
              name
            }      
            name
            
          }
          
      }
    }
`;

const GroupUserList_query = `
    query(
      $groupUuid: String!      
    ) {
      getAllGroupUsers(
        groupUuid: $groupUuid        
      ) {
          groupUserId
          groupId
          {
            name
          }
          tenantUserId
          {
            tenantUserId
            userId
            {
              firstName
              lastName
              email
              isActive
              
            }
            
          }          
      }
    }
`;

const CreateGroup_mutate = `
    mutation createGroup(
      $name: String!
      $clientId: Int!  
      $desc: String       
      ) {
      createGroup(
        name: $name,
        clientId: $clientId,
        desc: $desc,
         ) {
        group
        {
          groupId
          groupUuid
          clientId
            {
              name
            }
          
          name
          desc
          createDate
          updateDate
                
        }
      }
    }
`;

const GetGroupDataByName_query = `
    query( $name: String! , $clientId: Int! , $groupUuid: String)
    {
      getGroupDataByName(name:$name,clientId:$clientId,groupUuid:$groupUuid)
      {
          groupId
          groupUuid
          name  
          desc        
          clientId
            {
              clientId
              name
            }
          createBy
          createDate
          updateBy
          updateDate
      }
    }
`;

const GetGroupDataById_query = `
    query( $groupUuid: String!)
    {
      getGroupDataById(groupUuid:$groupUuid)
      {
          groupId
          groupUuid
          name  
          desc                 
          clientId
            {
              clientId
              name
            }
          createBy
          createDate
          updateBy
          updateDate
      }
    }
`;

const EditGroup_mutate = `
    mutation editGroup(      
      $name: String!
      $groupUuid: String! 
      $desc: String                
      ) {
      editGroup(        
        name: $name,
        groupUuid: $groupUuid,
        desc: $desc       
        ) {
        group
          {
            groupId
            groupUuid
            clientId
              {
                name
              }
            
            name   
            desc         
            createDate
            updateDate
          }
      }
    }
`;

const DeleteGroup_mutate = `mutation deleteGroup(
  $groupId:Int!
  ){
  deleteGroup(
    groupId: $groupId,
  ){
    response
  }
}`;


const UpdateGroupPermissions_mutate = `
    mutation updateGroupModulepageAction(      
      $groupUuid: String!
      $modulepageId: Int! 
      $actionCommonPermission: String!  
      $actionAdditionalPermission: String!
                    
      ) {
      updateGroupModulepageAction(        
        groupUuid: $groupUuid,
        modulepageId: $modulepageId,
        actionCommonPermission: $actionCommonPermission ,
        actionAdditionalPermission: $actionAdditionalPermission,            
        ) {
        groupModulepageAction
          {
            groupModulepageActionId
            groupId
            {
              groupId
              name
            }
            modulepageId
            {
              modulepageId
              name
            }
            actionCommonPermission
            actionAdditionalPermission 
          }
      }
    }
`;

const GetAllGroupPermissions_query = `
    query( $groupUuid: String!)
    {
      getAllGroupPermissions(groupUuid:$groupUuid)
      {
          moduleId
          name
  
          modulepage
          {
            moduleId
            {
              moduleId
            }
            modulepageId
            name
            actionCommonName
            actionAdditionalName
          }
          groupModulepageAction
          {
            groupModulepageActionId
            modulepageId
            
            access
            actionCommonPermission
            actionAdditionalPermission
            
          }       
      }
    }
`;

const GetStaffClientGroups_query = `query($username: String!, $clientId: Int!){
  getStaffClientGroups(username: $username, clientId: $clientId){
    groupId
    groupUuid
    name
    desc
  }
}`;

const GetStaffGroups_query = `query($username: String!){
  getStaffGroups(username: $username){
    groupUserId
    groupId{
      groupId
      name
    }
    tenantUserId
    {
     tenantId
     {
      name
     }
    }    
  }
}`;

module.exports = {
  CLIENT_GROUP_LIST_QUERY: ClientGroupList_query,
  CREATE_GROUP_MUTATION: CreateGroup_mutate,
  GET_GROUP_DATA_BY_NAME: GetGroupDataByName_query,
  GET_GROUP_DATA_BY_ID: GetGroupDataById_query,
  EDIT_GROUP_MUTATION: EditGroup_mutate,
  DELETE_GROUP_MUTATION: DeleteGroup_mutate,
  UPDATE_GROUP_PERMISSIONS: UpdateGroupPermissions_mutate,
  GET_ALL_GROUP_PERMISSIONS_QUERY: GetAllGroupPermissions_query,
  GET_ALL_GROUP_USERS_QUERY: GroupUserList_query,
  GET_STAFF_CLIENT_GROUPS: GetStaffClientGroups_query,
  GET_STAFF_GROUPS: GetStaffGroups_query,
};
